var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPressInc42 = function SvgPressInc42(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 86.4628,
    height: 24.0001,
    viewBox: "0 0 86.4628 24.0001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7414 7.02295C46.3346 6.55789 43.8906 6.31579 42.1719 6.31579C36.0949 6.31579 33.907 8.84274 33.907 13.2632V17.2632C33.907 21.2693 35.4023 24 42.5957 24C44.5036 24 46.8547 23.8274 49.1652 23.3684V19.7895C47.3571 20.1284 45.6758 20.2105 43.0196 20.2105C40.1684 20.2105 38.5693 18.8274 38.5693 16.4211V14.1053C38.5693 11.5598 39.8359 10.1053 42.3838 10.1053C42.8068 10.1053 43.6362 10.1107 44.0792 10.2221V12.8421H48.7414V7.02295ZM29.2448 12.8421C29.2448 8.0821 27.0655 6.31579 23.0992 6.31579C21.5979 6.31579 20.1431 6.73158 18.437 7.57895L18.0131 6.73684H11.8675V10.5263H14.4105V20.2105H12.2913V24H21.1919V20.2105H19.0727V10.5352C20.028 10.196 20.9834 10.1053 22.075 10.1053C24.8106 10.1053 24.5826 12.4775 24.5826 14.1141V24H31.7879V20.2105H29.2448V12.8421ZM7.20525 20.2105H9.74828V24H0V20.2105H2.54303V3.78947H0.423838V0H9.32444V3.78947H7.20525V20.2105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2244 8.0001C82.2244 6.24873 81.5941 3.78957 78.6218 3.78957C75.4962 3.78957 74.0507 6.80557 75.0147 10.1054H70.8435C70.5275 9.15926 70.3387 6.52599 71.3491 4.43231C72.4638 2.12241 75.094 9.91821e-05 78.5688 9.91821e-05H69.9331H62.7278L53.8272 13.2633V18.9475H63.3636V15.158H58.2775L65.6947 3.78957H65.9066V24.0001H69.9331C69.9331 16.53 74.3116 14.1098 78.4099 12.4016C80.6649 11.4616 82.2244 10.3028 82.2244 8.0001ZM86.4628 7.78957V20.2106H75.8668C75.8668 18.1054 77.8491 17.7468 80.3171 16.4212C83.4862 14.7188 86.4628 12.6317 86.4628 7.78957Z",
    fill: "#EC2124"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPressInc42);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/press-inc42.fc2b461954dab5353f4a1195af943dee.svg";